document.addEventListener("DOMContentLoaded", () => {
  const headers = document.querySelectorAll(".js-header");
  if (headers.length > 1 ) {
    const activeHeader = [...document.querySelectorAll(".js-header")]
      .find(header => getComputedStyle(header).display !== "none");
    const nonActiveHeader = [...document.querySelectorAll(".js-header")]
      .find(header => getComputedStyle(header).display === "none");
    if (activeHeader) {
      let nonActiveHeaderParent = nonActiveHeader.closest('.header-section');
      nonActiveHeaderParent.remove();
    }
  }
});